export const calendar = {
  today: 'Today: {{date}}',
}
